<template>
  <a-modal
    title="发送"
    width="1000px"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="loading"
    @cancel="handleCancel"
    @ok="handleOk"
    okText="发送"
  >
    <a-spin :spinning="is_spinning">
      <div id="printContent">
        <a-form
          ref="form"
          :model="modifyModal.form.model"
          :rules="modifyModal.form.rules"
          :layout="modifyModal.form.settings.layout"
          :label-col="modifyModal.form.settings.labelCol"
          :wrapper-col="modifyModal.form.settings.wrapperCol"
          :labelAlign="modifyModal.form.settings.labelAlign"
          scrollToFirstError
        >
          <field-render
            v-for="field in modifyModal.form.fields"
            v-model:value="modifyModal.form.model[field.name]"
            :field="field"
            :formModel="modifyModal.form.model"
            :key="field.name"
            :validateInfos="modifyModal.validateInfos"
            :options="modifyModal.options[field.datasource ? field.datasource : field.name]"
          />
          <a-form-item>
            <a-button size="small" type="primary" @click="handleQuery" class="no-print">
              查询
            </a-button>
          </a-form-item>
        </a-form>
        <div class="my2">
          <a-table
            v-if="state.CZRecord.dataSource.length > 0"
            :scroll="false"
            :columns="state.CZRecord.columns"
            row-key="id"
            :data-source="state.CZRecord.dataSource"
            :pagination="false"
          ></a-table>
          <a-table
            v-if="state.BuyRecord.dataSource.length > 0"
            :scroll="false"
            :columns="state.BuyRecord.columns"
            row-key="id"
            :data-source="state.BuyRecord.dataSource"
            :pagination="false"
          ></a-table>
          <a-table
            v-if="state.RemoveRecord.dataSource.length > 0"
            :scroll="false"
            :columns="state.RemoveRecord.columns"
            row-key="id"
            :data-source="state.RemoveRecord.dataSource"
            :pagination="false"
          ></a-table>
          <a-table
            v-if="state.UsedRecord.dataSource.length > 0"
            :scroll="false"
            :columns="state.UsedRecord.columns"
            row-key="id"
            :data-source="state.UsedRecord.dataSource"
            :pagination="false"
          ></a-table>

          <div style="padding-left:15px;">客户签字:</div>
        </div>
      </div>
    </a-spin>
    <template #footer>
      <a-button key="submit" @click="handleCancel">取消</a-button>
      <a-button key="back" v-print="'#printContent'">打印</a-button>
      <a-button key="submit" type="primary" @click="handleOk">发送</a-button>
    </template>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from 'vue';
import { message, Modal } from 'ant-design-vue';
import { reactive } from 'vue';
import {
  query_custom_all_can_send_receipt_by_date,
  send_receipt_record,
} from '@/api/mjstore-model';
import { notification } from 'ant-design-vue';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import moment from 'moment';
import { event_obj } from '@/components/page-model/mjstore/mjstore-orderrecord-config';

export default defineComponent({
  name: 'Receiptrecordmodel',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    obj: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['ok', 'cancel'],
  setup(props: any, { emit }: any) {
    const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
    const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
    const loading = ref(false);
    const is_spinning = ref(false);
    const formModel = reactive({
      date: moment().format('YYYY-MM-DD'),
      receipt_record_id: null,
      ...props.obj,
    });
    const modifyModal = reactive({
      title: '发送',
      form: {
        settings: {
          labelAlign: 'right',
          layout: 'inline',
          labelCol: {
            span: 10,
          },
          wrapperCol: {
            span: 14,
          },
        },
        fields: [
          {
            type: 'datepicker',
            name: 'date',
            label: '业务日期',
            disabled: false,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            format: 'YYYY-MM-DD',
            valueFormat: 'YYYY-MM-DD',
            showTime: false,
            placeholder: '请选择业务日期',
          },
        ],
        rules: {},
        model: formModel,
      },
      validateInfos: {},
      options: {},
    });
    const CZRecordDataSource: Array<any> = reactive([]);
    const BuyRecordDataSource: Array<any> = reactive([]);
    const RemoveRecordDataSource: Array<any> = reactive([]);
    const UsedRecordDataSource: Array<any> = reactive([]);

    const state = reactive({
      CZRecord: {
        columns: [
          {
            title: '充值金额',
            dataIndex: 'price',
            key: 'price',
            width: 150,
          },
          {
            title: '返利金额',
            dataIndex: 'cz_flje',
            key: 'cz_flje',
            width: 150,
          },
          {
            title: '支付方式',
            dataIndex: 'sk_type__name',
            key: 'sk_type__name',
            width: 150,
          },
        ],
        dataSource: CZRecordDataSource,
      },
      BuyRecord: {
        columns: [
          {
            title: '购买项目',
            dataIndex: 'display_name',
            key: 'display_name',
            width: 150,
          },
          {
            title: '包含次数',
            dataIndex: 'display_num',
            key: 'display_num',
            width: 150,
          },
          {
            title: '划扣金额',
            dataIndex: 'display_price',
            key: 'display_price',
            width: 150,
          },
        ],
        dataSource: BuyRecordDataSource,
      },
      RemoveRecord: {
        columns: [
          {
            title: '撤单项目',
            dataIndex: 'display_name',
            key: 'display_name',
            width: 150,
          },
          {
            title: '撤销次数',
            dataIndex: 'display_num',
            key: 'send_data',
            width: 150,
          },
        ],
        dataSource: RemoveRecordDataSource,
      },
      UsedRecord: {
        columns: [
          {
            title: '耗用项目',
            dataIndex: 'display_name',
            key: 'display_name',
            width: 150,
          },
          {
            title: '项目次数',
            dataIndex: 'display_num',
            key: 'display_num',
            width: 150,
          },
          {
            title: '项目来源',
            dataIndex: 'origin_project_name',
            key: 'origin_project_name',
            width: 150,
          },
          {
            title: '来源划扣次数',
            dataIndex: 'display_origin_project_num',
            key: 'display_origin_project_num',
            width: 150,
          },
        ],
        dataSource: UsedRecordDataSource,
      },
    });
    onMounted(() => {
      loadData();
    });

    const loadData = () => {
      is_spinning.value = true;
      query_custom_all_can_send_receipt_by_date({
        org_id: current_org?.id,
        customer_id: props.obj.customer_id,
        business_date: modifyModal.form.model.date,
        shop_id: current_shop?.id,
      })
        .then((res: any) => {
          formModel.receipt_record_id = res.id;
          CZRecordDataSource.length = 0;
          BuyRecordDataSource.length = 0;
          RemoveRecordDataSource.length = 0;
          UsedRecordDataSource.length = 0;

          res.send_data.CZRecord.map((item: any) => {
            CZRecordDataSource.push(item);
          });
          res.send_data.CardRecord.map((item: any) => {
            item.display_name = item.card__name;
            if (item.card_type == 11) {
              item.display_num = '-';
            } else {
              item.display_num = `${item.total_num}次`;
            }
            if (item.kzk_card_record__card__name) {
              item.display_price = `划扣${item.kzk_card_record__card__name} ${item.kzk_num}次`;
            } else {
              item.display_price = `${item.czje + item.flje}元`;
            }
            BuyRecordDataSource.push(item);
          });
          res.send_data.OrderRecord.map((item: any) => {
            item.display_name = item.project__name;
            item.display_num = `${item.total_num}次`;
            item.display_price = `${item.czje + item.flje}元`;
            if (item.kzk_card_record__card__name) {
              item.display_price = `划扣${item.kzk_card_record__card__name} ${item.kzk_num}次`;
            } else {
              item.display_price = `${item.czje + item.flje}元`;
            }
            BuyRecordDataSource.push(item);
          });
          res.send_data.OrderRemove.map((item: any) => {
            item.display_name = item.order_record__project__name;
            item.display_num = `${item.num}次`;
            RemoveRecordDataSource.push(item);
          });
          res.send_data.CardRemove.map((item: any) => {
            item.display_name = item.card__name;
            if (item.card__card_type == 11) {
              item.display_num = '-';
            } else {
              item.display_num = `${item.num}次`;
            }
            RemoveRecordDataSource.push(item);
          });
          res.send_data.OrderUsedCancelRecord.map((item: any) => {
            item.display_name = item.order_used_record__project__name;
            item.display_num = `${item.num}次`;
            RemoveRecordDataSource.push(item);
          });
          res.send_data.OrderUsedRecord.map((item: any) => {
            item.display_name = item.project__name;
            item.display_num = `${item.num}次`;
            item.display_origin_project_num = `${item.origin_project_num}次`;
            UsedRecordDataSource.push(item);
          });
          message.success('查询成功');
        })
        .finally(() => {
          is_spinning.value = false;
        });
    };

    const handleCancel = () => {
      emit('cancel');
    };
    const handleOk = () => {
      Modal.confirm({
        title: '提示',
        content: '是否确认发送',
        onOk() {
          send_receipt_record({
            org_id: current_org.id,
            receipt_record_id: formModel.receipt_record_id,
          })
            .then(() => {
              notification.success({
                message: '成功',
                description: '发送成功',
              });
              emit('ok');
            })
            .finally(() => {
              loading.value = false;
            });
        },
        onCancel() {
          loading.value = false;
        },
      });
    };
    const handleQuery = () => {
      loadData();
    };
    return {
      // fullscreen
      message,
      // edit
      loading,
      is_spinning,
      state,
      modifyModal,
      handleCancel,
      handleQuery,
      handleOk,
    };
  },
});
</script>

<style lang="less" scoped>
.my2 .ant-table-column-title {
  font-weight: bold;
}
/* 去掉页眉和页脚样式开始 */
@page {
  margin: 7mm;  /* auto is the initial value */
  margin: 7mm;  /* t
  size: auto; rgin in the printer settings */
}

html {
  margin: 7px; or: #FFFFFF;
  margin: 7px;  //* this affects the margin on the html
  background-color: #ffffff;
}

body {
  margin: 10mm 15mm 10mm 15mm; rgin: 10mm 15mm 10mm 15mm; //* margin
  border: solid 1px blue;
}
/* 去掉页眉和页脚样式结束 */
@media print {
  .no-print {
    display: none;
  }
}
</style>
